import PropertySearchListingPage from "../PropertySearchModule/PropertySearchListingPage";

export default {
    path: '/property-search',
    component: PropertySearchListingPage,
    name: 'property.search',
};
